import { z } from "zod";

import { DISCRIMINATOR } from "./common";

const zErrorDetails = z.object({
  codeErrors: z.array(z.string()),
  debugMessage: z.string().optional(),
});

type UnsuccessfulShape<Status extends number | [number, number, ...number[]]> = {
  [DISCRIMINATOR]: z.ZodLiteral<Status>;
  body: z.ZodObject<{
    succeeded: z.ZodLiteral<false>;
    errorDetails: typeof zErrorDetails;
  }>;
};

function zUnsuccessful<const Status extends number>(status: Status) {
  return z.object({
    [DISCRIMINATOR]: z.literal(status),
    body: z.object({
      succeeded: z.literal(false),
      errorDetails: zErrorDetails,
    }),
  } as UnsuccessfulShape<Status>);
}

function zUnsuccessful2<const Status extends [number, number, ...number[]]>(status: Status) {
  return status.map((status) => zUnsuccessful(status)) as [
    ReturnType<typeof zUnsuccessful<Status[number]>>,
    ReturnType<typeof zUnsuccessful<Status[number]>>,
    ...ReturnType<typeof zUnsuccessful<Status[number]>>[],
  ];
}

export { zErrorDetails, zUnsuccessful, zUnsuccessful2 };
